
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'
import SendSmsApi from './src/SendSmsApi'


let apis = {
   TranResourcesApi,
   RegionList,
   SendSmsApi
};

export default apis;
